<app-nav></app-nav>
<app-top-header></app-top-header>

<div class="ParentSectionSection_Components_HTally">

    <div class="Body_ParentSectionSection_Components_HTally">
        <div class="InnerPart_Body_Renter_Htally">
            <div class="Parent_ActivityList_Dashboard TabsSection">

            <div class="InnerBodyOfComponents">
                <div class="TabsHeader">
                    <div class="RemainActivityList_Tab_Button">
                        <button (click)="selectTab('House')"
                            [class.active]="activeTab === 'House'">{{ 'house.houseTab' | t:'House' }} <span></span></button>
                        <button (click)="selectTab('Flat')"
                            [class.active]="activeTab === 'Flat'">{{ 'house.flatTab' | t:'Flat' }} <span></span></button>
                    </div>

                    <div class="TabsActions" *ngIf="activeTab === 'House' || activeTab === 'Flat'">
                        <button class="FilterBTN" [class.active-filter]="isFilterActive()" type="button" (click)="toggleFilter()">
                            {{ 'common.filter' | t:'Filter' }}
                        </button>
                        <button class="PositiveBTN" type="button" (click)="activeTab === 'House' ? openNewHouse() : openNewFlat()">
                            {{ activeTab === 'House' ? ('house.addHouse' | t:'Add House') : ('house.addFlat' | t:'Add Flat') }}
                        </button>
                    </div>
                </div>

                <div *ngIf="activeTab === 'House'" class="RemainActivityList_tab_content">
                    <app-house-list></app-house-list>
                </div>

                <div *ngIf="activeTab === 'Flat'" class="RemainActivityList_tab_content">
                    <app-flat-list></app-flat-list>
                </div>

            </div>

        </div>
    </div>
</div>

<app-new-edit-house
    *ngIf="showNewHouse"
    (close)="closeNewHouse()"
    (save)="handleHouseSave($event)"
></app-new-edit-house>

<app-new-edit-flat
    *ngIf="showNewFlat"
    [preselectedHouse]="flatCreateHousePreset"
    (close)="closeNewFlat()"
    (save)="handleFlatSave()"
></app-new-edit-flat>

<div class="modal-overlay prompt-overlay" *ngIf="showPostCreateFlatPrompt && pendingCreatedHouseForFlat" (click)="closePostCreateFlatPrompt()">
    <div class="post-create-prompt-modal" (click)="$event.stopPropagation()">
        <h3>{{ 'house.postCreatePromptTitle' | t:'Assign flat for the house' }} "{{ pendingCreatedHouseForFlat.houseName }}"?</h3>
        <p>{{ 'house.postCreatePromptMessage' | t:'You can add a flat now or skip this step for later.' }}</p>
        <div class="post-create-prompt-actions">
            <button type="button" class="panel-item" (click)="closePostCreateFlatPrompt()">{{ 'common.skipForNow' | t:'Skip for now' }}</button>
            <button type="button" class="PositiveBTN" (click)="openFlatCreateFromHousePrompt()">{{ 'house.addFlat' | t:'Add Flat' }}</button>
        </div>
    </div>
</div>

<app-filter-modal
    *ngIf="showFilter && (activeTab === 'House' || activeTab === 'Flat')"
    [fields]="activeTab === 'House' ? houseFilterFields : flatFilterFields"
    [value]="activeTab === 'House' ? houseFilterValues : flatFilterValues"
    (apply)="applyFilters($event[0], $event[1])"
    (reset)="resetFilters()"
    (close)="toggleFilter()"
></app-filter-modal>
</div>
